module.exports = __webpack_public_path__ + "img/logo_lexus.f3c07933.png";